import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=3c33e380&"
import script from "./Dash.vue?vue&type=script&lang=ts&"
export * from "./Dash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports